<template>
    <div ref="parentRef">
        <Dropdown :options="options" :value="adStatus" @input="updateStatus($event)" :loading="loading" />

        <Modal :title="'Cancel ad ' + name" :show="showCancelledModal" @close="showCancelledModal = false">
            <form @submit="onCancelSubmit">
                <textarea-input label="Please provide a reason" name="reason" :error="getFirstItem(errors.reason)" v-model="form.reason" />
            </form>

            <button class="btn btn-primary" @click="onCancelSubmit">Submit</button>
            <button class="btn btn-link"  @click.prevent="showCancelledModal = false">Close</button>
            <p v-if="! filterCancelled" class="text-info small mt-3 mb-0"><i class="fa fa-eye-slash"></i> Cancelled ads are hidden by default. You can update your filters to view all cancelled ads.</p>
        </Modal>

        <Modal :title="'Change status for ' + name" :show="showConfirmModal" @close="showConfirmModal = false">
            <p>Please confirm that you want to change ad {{ name }} to {{ intermediateValue }}.</p>
                <button class="btn btn-primary" @click="onConfirmSubmit">Submit</button>
                <button class="btn btn-link"  @click.prevent="showConfirmModal = false">Close</button>
        </Modal>

        <Modal :title="'Change status for ' + name" :show="showAlertModal" @close="showAlertModal = false">
            <p class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span  v-html="alertMessage"></span></p>
            <button class="btn btn-primary" @click.prevent="showAlertModal = false">Close</button>
        </Modal>

        <Modal :title="'Change status for ' + name" :show="showPlacementDateModal" @close="showPlacementDateModal = false">
             <p>Please provide a placement date to change ad {{ name }} to {{ intermediateValue }}.</p>

            <form @submit="onPlacementDateSubmit">
                <text-input
                    classe="datepicker"
                    label="Placement date"
                    name="placement_date"
                    :show-dates-tooltips="showDatesTooltips"
                    :min="min"
                    :max="max"
                    :error="getFirstItem(errors.placement_date)"
                    v-model="form.placement_date" />
            </form>

            <button class="btn btn-primary" @click="onPlacementDateSubmit">Submit</button>
            <button class="btn btn-link"  @click.prevent="showPlacementDateModal = false">Close</button>
        </Modal>
    </div>
</template>

<script>
import Dropdown from './Dropdown/Dropdown.vue';
import Modal from "./Modal";
import TextareaInput from './Inputs/TextareaInput.vue';
import TextInput from './Inputs/TextInput.vue';
import GetFirstItem from '../mixins/GetFirstItem.js';

export default {
    name: "AdStatusDropdown",
    props: {
        id: { type: String, required: true },
        name: { type: String, required: true },
        status: { type: String, required: true },
        options: { type: Array, required: true },
        isAdmin: { type: Boolean, required: true},
        placementDate: { type:String, default: '', required: false},
        dayBeforeMin: { type:String, default: '', required: false},
        dayAfterMax: { type:String, default: '', required: false},
        min: { type:String, default: '', required: false},
        max: { type:String, default: '', required: false},
        filterCancelled: { type: Boolean, default:false, required: false},
    },
    components: {
        Dropdown,
        Modal,
        TextareaInput,
        TextInput
    },
    computed: {
        showDatesTooltips() {
            let a = {};
            if(this.dayBeforeMin) {
                a[this.dayBeforeMin] = 'Delivery deadline';
            }

            if(this.dayAfterMax) {
                a[this.dayAfterMax] = 'End date';
            }

            return a;
        },
        intermediateValue() {
            for (let option of this.options) {
                if (this.intermediateStatus === option.key) {

                    return option.value;
                }
            }
        },
    },
    mixins: [GetFirstItem],
    data() {
        return {
            adStatus: 'reserved', // immediately overwritten in mounted() but prevents bug
            intermediateStatus: '',
            loading: false,
            showCancelledModal: false,
            showConfirmModal: false,
            showAlertModal: false,
            showPlacementDateModal: false,
            alertMessage: "",
            form: {
                reason: '',
                placement_date: '',
            },
            errors: {},
            savedPlacementDate: '',
        };
    },
    mounted() {
        this.adStatus = this.status;
    },
    methods: {
        resetValues() {
            this.intermediateStatus = '',
            this.alertMessage = '';
            this.form.reason =  '';
            this.form.placement_date = ! this.savedPlacementDate ? this.placementDate : this.savedPlacementDate;
            this.errors =  {};
        },
        findOptionWithValue(value) {

            return this.options.find(function(option) { return option.key == value; });
        },
        updateStatus(value) {
            this.resetValues();
            this.intermediateStatus = value;

            const intermediateOption = this.findOptionWithValue(value);
            const currentOption = this.findOptionWithValue(this.adStatus);

            if (value == 'cancelled') {
                this.showCancelledModal = true;
            } else if(! this.isAdmin && intermediateOption.sequence < currentOption.sequence) {
                this.alertMessage = "You are not allowed to change the status back to " + intermediateOption.value + ".";
                this.showAlertModal = true;
            } else if((this.intermediateStatus == 'published'|| this.intermediateStatus == 'completed') && this.form.placement_date == '') {
                this.showPlacementDateModal = true;
            } else {
                this.showConfirmModal = true;
            }
        },
        onPlacementDateSubmit() {
            this.loading = true;

            let params = JSON.parse(JSON.stringify(this.form));//deep clone
            params.status = this.intermediateStatus;

            axios.post('/api/status/' + this.id, params).then(() => {
                this.loading = false;
                this.showPlacementDateModal = false;
                this.adStatus = this.intermediateStatus;
                this.$refs.parentRef.closest('tr').querySelector('[data-column="placement_date"] span').innerText = this.form.placement_date;
                this.savedPlacementDate = this.form.placement_date;
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.status == 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        onCancelSubmit() {
            this.loading = true;

            let params = JSON.parse(JSON.stringify(this.form));//deep clone
            params.status = this.intermediateStatus;

            axios.post('/api/status/' + this.id, params).then(() => {
                this.loading = false;
                this.showCancelledModal = false;
                this.adStatus = this.intermediateStatus;
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.status == 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        onConfirmSubmit() {
            this.loading = true;
            this.showConfirmModal = false;

            let params = {};
            params.status = this.intermediateStatus;

            axios.post('/api/status/' + this.id, params).then(() => {
                this.loading = false;
                this.adStatus = this.intermediateStatus;
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.status == 422) {
                    this.alertMessage = error.response.data.message;
                    this.showAlertModal = true;
                }
            });
        },
    },
}
</script>

<style scoped>

</style>